import { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import CircularProgress from "@mui/material/CircularProgress";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { useForm } from "react-hook-form";
import configurations from "config";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/common.css';
import Backdrop from '@mui/material/Backdrop';

function ForgotPassword() {
  const { t } = useTranslation();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    await axios.post(baseUrl + '/vendor/forgotPassword', data,
      {
        headers: { function: azureFunctionVendorFrontendKey }
      }).then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          const message = response.data.message;
          if (response.data.status == 1) {
            toast.success(t(message));
          }
          else {
            if (message != '')
              toast.error(t(message));
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      }).catch(error => {
        setIsLoading(false);
        toast.error(error);
      });
  };

  return (
    <BasicLayout image={bgImage}>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center" >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>{t('forgotPassword')}</MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label={t('email')}
                name="email"
                {...register("email", {
                  required: {
                    value: true,
                    message: t('emailRequired')
                  },
                  pattern: {
                    value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                    message: t('invalidEmail')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.email && (<p className="errorMsg">{errors.email.message}</p>)}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('submit')}</MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                {t('dontHaveAccount')}
                <MDTypography
                  component={Link}
                  to="/vendor/login"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  {t('signIn')}
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ForgotPassword;
